import {CategoryTree} from "../repository/CategoryTree.repo";
import {
    Checkbox,
    FormControlLabel,
    ListSubheader,
    MenuItem,
    MenuList,
    Select,
    SvgIcon,
    SvgIconProps
} from "@mui/material";
import React, {useCallback, useEffect, useRef, useState} from "react";
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LabelIcon from '@mui/icons-material/Label';
import TreeItem from '@mui/lab/TreeItem';
type Props = {
    categories: CategoryTree[],
    selected: string[];
    onChange: (selected: string[]) => void;
    multiple?: boolean
}

export default function CategorySelectBox(props: Props){

    const getOnChange = useCallback((status: boolean, clickedID: number) => {

        console.log(status, clickedID)

        if(status){
            props.onChange([...props.selected, clickedID.toString()]);
        }else{
            props.onChange(props.selected.filter((i) => i  !== clickedID.toString()));
        }


    }, [props.selected]);

    const findSubsTree = useCallback((categoryID: number, comingFromParent?: boolean) => {
        const parent = props.categories.find((parentCat) => parentCat.ID === categoryID);
        const subs = props.categories.filter((category) => category.ParentID === categoryID);
        if(parent === undefined){
            return;
        }

        if(comingFromParent){
            return (<>{subs.map((category) => (
                <TreeItem nodeId={category.ID.toString()} label={
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={props.selected.findIndex((i) => i === category.ID.toString()) !== -1}
                                onChange={(event) =>
                                    getOnChange(event.currentTarget.checked, category.ID)
                                }
                                onClick={(e) => e.stopPropagation()}
                            />
                        }
                        label={<>{category.Name}</>}
                        key={category.ID}
                    />
                }>
                    {findSubsTree(category.ID, true)}
                </TreeItem>
            ))}</>)
        }


        return (
            <TreeItem nodeId={parent.ID.toString()} label={
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={props.selected.findIndex((i) => i === parent.ID.toString()) !== -1}
                            onChange={(event) =>
                                getOnChange(event.currentTarget.checked, parent.ID)
                            }
                            onClick={(e) => e.stopPropagation()}
                        />
                    }
                    label={<>{parent.Name}</>}
                    key={parent.ID}
                />
            }>
                {subs.map((category) => (
                    <TreeItem nodeId={category.ID.toString()} label={
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.selected.findIndex((i) => i === category.ID.toString()) !== -1}
                                    onChange={(event) =>
                                        getOnChange(event.currentTarget.checked, category.ID)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                />
                            }
                            label={<>{category.Name}</>}
                            key={category.ID}
                        />
                    }>
                        {findSubsTree(category.ID, true)}
                    </TreeItem>
                ))}
            </TreeItem>
        )
    }, [getOnChange, props.categories, props.selected]);


    return (
            <TreeView
                aria-label="Category Tree"
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                multiSelect={props.multiple}
                sx={{ height: 264, flexGrow: 1, width: '99%', overflowX: 'hidden', overflowY: 'auto', textAlign: 'initial' }}
            >
                {props.categories.filter(cat => cat.ParentID === null).map((category) => findSubsTree(category.ID))}
            </TreeView>
    )




}


